import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData, editData, getList } from '../../helpers/fackBackend_Helper';

function* addChatrBulkRechargeResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/createChatrBulkRechargeRequest', data);
        if (response.Status) {
            yield put(actions.addChatrBulkRechargeSuccess(response.Message));
            yield put(actions.getChatrRechargeRequestList(searchData));
        } else {
            yield put(actions.addChatrBulkRechargeFailed(response.Message));
            yield put(actions.getChatrRechargeRequestList(searchData));
        }
    } catch (error) {
        yield put(actions.addChatrBulkRechargeFailed(error));
    }
}

function* getChatrRechargeRequestResponse({ payload: { searchData } }) {
    try {
        const response = yield call(addData, '/chatrRechargeRequestList', searchData);
        if (response?.response?.Status) {
            yield put(actions.getChatrRechargeRequestListSuccessful(response?.response?.data));
        } else {
            yield put(actions.getChatrRechargeRequestListFailed(response?.response?.Message));
        }
    } catch (error) {
        yield put(actions.getChatrRechargeRequestListFailed(error));
    }
}

function* getChatrBatchTransactionIdRechargeResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/getChatrRechargeBatchData/${data.batchID}`,);
        if (response.response?.Status) {
            yield put(actions.getChatrBatchTransactionIdRechargeRequestSuccessful(response.response.Data,),);
        } else {
            yield put(actions.getChatrBatchTransactionIdRechargeRequestFailed(response.response.Message,),);
        }
    } catch (error) {
        yield put(actions.getChatrBatchTransactionIdRechargeRequestFailed(error));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.ADD_CHATR_BULK_RECHARGE, addChatrBulkRechargeResponse)]);
    yield all([takeEvery(actions.GET_CHATR_RECHARGE_REQUEST_LIST, getChatrRechargeRequestResponse)]);
    yield all([takeEvery(actions.GET_CHATR_BATCHTRANSACTIONBYID_RECHARGE_REQUEST, getChatrBatchTransactionIdRechargeResponse)]);
}